/**
 * Controls when Access Management should skip a login-status network request.
 * Only in-flight requests are skipped; a cached status must not block refetch
 * (otherwise stale Legacy can persist after Auth0/Salesforce state changes).
 */
export const normalizeLoginStatusEmailKey = (email) => (email || '').trim();

export const shouldSkipLoginStatusFetch = (entry, { force = false } = {}) => {
	if (force) return false;
	if (!entry) return false;
	return !!entry.loading;
};

export const clearLoginStatusEntry = (state, email) => {
	const emailKey = normalizeLoginStatusEmailKey(email);
	if (!emailKey || !state[emailKey]) return state;
	const next = { ...state };
	delete next[emailKey];
	return next;
};

export const getLoginStatusRtkCacheKey = (email) =>
	`userLoginStatus-${normalizeLoginStatusEmailKey(email)}`;
